import { GridContainerFullHeight, TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

interface IUniqueIdSerieFormProps extends IForm {}

const UniqueIdSerieForm = (props: IUniqueIdSerieFormProps) => {
  const { mode, values, requiredFields, onCallbackChange } = props;

  const isViewMode = mode === 'view';

  return (
    <GridContainerFullHeight>
      <TextInput
        label="Name"
        value={values.name}
        onChangeValue={onCallbackChange('name')}
        isReadOnly={isViewMode}
        required={requiredFields.includes('name')}
      />
      <TextInput
        label="Prefix"
        value={values.prefix}
        onChangeValue={onCallbackChange('prefix')}
        isReadOnly={isViewMode}
        required={requiredFields.includes('prefix')}
      />
      <TextInput
        label="Number of digits"
        value={values.numCaracters}
        onChangeValue={onCallbackChange('numCaracters')}
        isReadOnly={isViewMode}
        required={requiredFields.includes('numCaracters')}
      />
    </GridContainerFullHeight>
  );
};

export default UniqueIdSerieForm;
